function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#29B587",
  d: "M814 36v-9h-93v9zm13-9v-9H710v9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2BA691",
  d: "M722 36v-9h-8v9zm-12-9v-9h-46v9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2A8F9D",
  d: "M714 36v-9h-73v9zm-50-9v-9H560v9zm81-9V9h-5v9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#285D99",
  d: "M641 36v-9h-86v9zm-80-9v-9h-95v9zm180-9V9h-42v9zm31-9V0h-50v9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2B4697",
  d: "M769 45v-9h-47v9zm-214-9v-9h-39v9zm-89-9v-9H334v9zm233-9V9h-54v9zm23-9V0h-27v9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2E3195",
  d: "M723 45v-9h-20v9zm-207-9v-9h-80v9zm-182-9v-9H226v9zm311-9V9h-83v9zm51-9V0h-45v9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#512D93",
  d: "M704 45v-9h-29v9zm-268-9v-9h-28v9zm-210-9v-9h-65v9zm337-9V9h-24v9zm88-9V0h-14v9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C2E92",
  d: "M676 45v-9zm-268-9v-9h-75v9zm-247-9v-9h-43v9zm378-9V9h-42v9zm98-9V0h-44v9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7A3390",
  d: "M675 45v-9h-31v9zm-342-9v-9h-46v9zm-215-9v-9H0v9zm379-9V9H379v9zm96-9V0h-31v9z"
}));

function SvgDividerRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 741 45"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3NDEgNDUiPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHBhdGggZmlsbD0iIzI5QjU4NyIgZD0iTTgxNCAzNnYtOWgtOTN2OXpNODI3IDI3di05SDcxMHY5eiIvPjxwYXRoIGZpbGw9IiMyQkE2OTEiIGQ9Ik03MjIgMzZ2LTloLTh2OXpNNzEwIDI3di05aC00NnY5eiIvPjxwYXRoIGZpbGw9IiMyQThGOUQiIGQ9Ik03MTQgMzZ2LTloLTczdjl6TTY2NCAyN3YtOUg1NjB2OXpNNzQ1IDE4VjloLTV2OXoiLz48cGF0aCBmaWxsPSIjMjg1RDk5IiBkPSJNNjQxIDM2di05aC04NnY5ek01NjEgMjd2LTloLTk1djl6TTc0MSAxOFY5aC00MnY5ek03NzIgOVYwaC01MHY5eiIvPjxwYXRoIGZpbGw9IiMyQjQ2OTciIGQ9Ik03NjkgNDV2LTloLTQ3djl6TTU1NSAzNnYtOWgtMzl2OXpNNDY2IDI3di05SDMzNHY5ek02OTkgMThWOWgtNTR2OXpNNzIyIDlWMGgtMjd2OXoiLz48cGF0aCBmaWxsPSIjMkUzMTk1IiBkPSJNNzIzIDQ1di05aC0yMHY5ek01MTYgMzZ2LTloLTgwdjl6TTMzNCAyN3YtOUgyMjZ2OXpNNjQ1IDE4VjloLTgzdjl6TTY5NiA5VjBoLTQ1djl6Ii8+PHBhdGggZmlsbD0iIzUxMkQ5MyIgZD0iTTcwNCA0NXYtOWgtMjl2OXpNNDM2IDM2di05aC0yOHY5ek0yMjYgMjd2LTloLTY1djl6TTU2MyAxOFY5aC0yNHY5ek02NTEgOVYwaC0xNHY5eiIvPjxwYXRoIGZpbGw9IiM2QzJFOTIiIGQ9Ik02NzYgNDV2LTl6TTQwOCAzNnYtOWgtNzV2OXpNMTYxIDI3di05aC00M3Y5ek01MzkgMThWOWgtNDJ2OXpNNjM3IDlWMGgtNDR2OXoiLz48cGF0aCBmaWxsPSIjN0EzMzkwIiBkPSJNNjc1IDQ1di05aC0zMXY5ek0zMzMgMzZ2LTloLTQ2djl6TTExOCAyN3YtOUgwdjl6TTQ5NyAxOFY5SDM3OXY5ek01OTMgOVYwaC0zMXY5eiIvPjwvZz48L3N2Zz4=";
export { SvgDividerRight as ReactComponent };